import PageTemplate from "../sections/pageTemplate";

const ErrorPage = () => {
    return(
        <PageTemplate>
            <div>error</div>
        </PageTemplate>
    )
}

export default ErrorPage;